import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { Button } from 'antd';
import { apiConfig, apiGetPage, apiGetCustom } from '../../request/api';
import { imageUrl, zeusApp } from '../../request/index';
import { SendOutlined, SwapRightOutlined } from '@ant-design/icons';
import { useCustomData } from '../../pages/context/indexCustomDataContext';
import '../../assets/css/home.css';

interface PageData {
    id: string;
    newstitle: string;
    onlineTime: string;
    newsContent: string;
    newsImage: string;
    state: string | null;
}

interface newItem {
    newTitle: string;
    newsImage: string;
    newsTime?: string;
    id: string;
}

const HomePart2: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const navigate = useNavigate();
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [hoverIndex, setHoverIndex] = useState<number>(0);
    const [title, setTitle] = useState<string>('');
    const { getValue } = useCustomData();
    const knowMore = getValue('knowMore');
    const [lang, setLang] = useState<'zh' | 'en'>('zh');
    
    const [newList, setNewList] = useState<newItem[]>([]);
    const pageSize = 3; // 首页只显示3条新闻
    useEffect(() => {
        const code = localStorage.getItem('siteLanguage') || 'zh';
        setLang(code === 'en' ? 'en' : 'zh');
    }, []);
    useEffect(() => {
        loadData();
    }, [lang]);

    const text = {
        zh: {
            title: '新闻热点',
            knowMore: '了解更多',
        },
        en: {
            title: 'News Highlights',
            knowMore: 'Learn More',
        }
    };
    const t = text[lang];

    const loadData = () => {
        apiGetPage({
            tid: '3E0B92D9B5834E49B146D40BAE5814DG',
            page: 1, // 固定第一页
            size: pageSize,
            sort: 'onlineTime-',
            search: '',
            languagecode: languageCode
        })
        .then(res => {
            const newRows = res.data.data.rows;
            
            // 确保只取前3条数据
            const limitedRows = newRows.slice(0, pageSize);
            
            // 转换数据格式为 newItem
            const transformedData: newItem[] = limitedRows.map((item: PageData) => ({
                id: item.id,
                newTitle: item.newstitle,
                newsImage: item.newsImage,
                newsTime: item.onlineTime
            }));
            
            setNewList(transformedData);
        })
        .catch(err => {
            console.log('加载新闻失败', err);
            // 如果API请求失败，使用备用数据
            const fallbackData: newItem[] = [
                {
                    id: '1',
                    newTitle: '新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题',
                    newsImage: '',
                    newsTime: '2025.11.12'
                },
                {
                    id: '2',
                    newTitle: '新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题',
                    newsImage: '',
                    newsTime: '2025.11.12'
                },
                {
                    id: '3',
                    newTitle: '新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题',
                    newsImage: '',
                    newsTime: '2025.11.12'
                }
            ];
            // 确保备用数据也只显示3条
            setNewList(fallbackData.slice(0, pageSize));
        });
    };

    return (
        <div className="home-part2">

                <div className='newsTitle-h1'>
                    {t.title}
                </div>
            <div className="newList">
                {newList.map((item, index) => (
                    <div 
                        className='newsItem' 
                        key={item.id}
                        onClick={() => navigate('/news')}
                        style={{ cursor: 'pointer' }}
                    >
                        {/* B183A235B5F6491682FD4B6849CF6368 */}
                        <div className="newsImage">
                            <img 
                                src={item.newsImage ? `${imageUrl}${item.newsImage}?zeus-app=${zeusApp}` : '/default-news-image.png'}
                                alt={item.newTitle}
                                onError={(e) => {
                                    (e.target as HTMLImageElement).src = '/default-news-image.png';
                                }}
                            />
                        </div>
                        <div className='newTitle'>{item.newTitle}</div>
                        <div className='newsTime'>{item.newsTime}</div>
                    </div>
                ))}
                
                {/* 如果新闻数量不足3条，显示占位符 */}
                {newList.length < pageSize && 
                    Array.from({ length: pageSize - newList.length }).map((_, index) => (
                        <div 
                            className='newsItem placeholder' 
                            key={`placeholder-${index}`}
                            style={{ visibility: 'hidden' }}
                        >
                            {/* 占位符内容，保持布局一致 */}
                            <div className="newsImage"></div>
                            <div className='newTitle'></div>
                            <div className='newsTime'></div>
                        </div>
                    ))
                }
            </div>
            <div className='home-part2_left_button'>
                <Button
                    style={{
                        backgroundColor: '#ac9455',
                        width: '160px',
                        height: '36px',
                        borderRadius: '18px'
                    }}
                    type="primary"
                    onClick={() => navigate('/news')}
                >
                    {t.knowMore}
                </Button>
            </div>
        </div>
    );
};

export default HomePart2;